﻿$.fn.dxCtrlBuilderEmailStyleLargeur = function custom_dxCtrlBuilderEmailStyleLargeur(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlbuilderemailstylelargeur dx-ctrl");
        this.createInstance(new cdxCtrlBuilderEmailStyleLargeur(this, option));
    }
    return this;
}

window.cdxCtrlBuilderEmailStyleLargeur = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty();

        var valueLargeur = ((option.value.length == 0) ? "Défaut" : ((option.value == 30) ? "Petit" : ((option.value == 50) ? "Moyen" : ((option.value == 90) ? "Grand" : "..."))))
        var ds = ["Petit", "Moyen", "Grand", "..."]
        if (option.allowDefaut) ds.unshift("Défaut")
        $("<div/>").appendTo(container).dxCtrlRadioButton({
            dataSource: ds,
            value: valueLargeur,
            layout: 'horizontal',
            itemTemplate: function (itemData, itemIndex, itemElement) {
                if (itemData == "Défaut") {
                    itemElement.html("<i class='fas fa-text-slash'></i>")
                    itemElement.attr("title", "Utiliser le style par défaut")
                } else {
                    itemElement.text(itemData)
                    itemElement.attr("title", itemData)
                }
            },
            onValueChanged: function (e) {
                $DivTaille.css("display", "none")
                switch (e.value) {
                    case "Défaut":
                        dxLargeur.option("value", parseInt(""))
                        option.onValueChanged("")
                        break;
                    case "Petit":
                        dxLargeur.option("value", 30)
                        option.onValueChanged(30)
                        break;
                    case "Moyen":
                        dxLargeur.option("value", 50)
                        option.onValueChanged(50)
                        break;
                    case "Grand":
                        dxLargeur.option("value", 90)
                        option.onValueChanged(90)
                        break;
                    case "...":
                        $DivTaille.css("display", "");
                        if (option.value.length == 0) {
                            option.value = 30
                            dxLargeur.option("value", 30);
                        } else { dxLargeur.repaint() }
                        dxLargeur.repaint()
                        break;
                }
            }
        })

        var $DivTaille = $("<div style='display:" + ((valueLargeur == "...") ? "" : "none") + ";'/>").appendTo(container)
        //$("<div style='padding-top:5px;opacity:0.3;font-size:12px;padding-left:16px;'>Largeur du bouton</div>").appendTo($DivTaille)
        var timeOutSlider = null
        var dxLargeur = $("<div/>").appendTo($DivTaille).dxSlider({
            min: ((typeof option.min == 'undefined') ? 0 : option.min),
            max: ((typeof option.max == 'undefined') ? 100 : option.max),
            value: parseInt(option.value),
            onValueChanged: function (e) {
                window.clearTimeout(timeOutSlider)
                timeOutSlider = window.setTimeout(function () {
                    option.value = ((isNaN(e.value)) ? "" : e.value)
                    option.onValueChanged(option.value)
                }, 1000)
            },
            tooltip: {
                enabled: true,
                format(value) {
                    if (isNaN(value)) { return `Largeur: Défaut`; }
                    else { return `Largeur: ${value}%`; }
                },
                showMode: 'always',
                position: 'bottom',
            },
            onContentReady: function (e) { window.setTimeout(function () { e.component.repaint() }, 0) }
        }).dxSlider("instance")
    }

    this.element = function () { return container }

    mConstruit();
}